// extracted by mini-css-extract-plugin
module.exports = {"menu":"incomplete-profile-hamburger-menu-list_component_menu__YoGsA"};